.cellHeader {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 10px;
}

.chartLabelRow {
    display: flex;
    justify-content: center;
    margin-top: 10px;
}

.filters{
    display: flex;
    gap: 10px;
}
